import { Component, Vue } from "vue-property-decorator";
import VueCookies from 'vue-cookies'
import AgentComponent from './Agent.component.vue';
Vue.use(VueCookies)

@Component({
    components: {
        AgentComponent
    }
})

default class AddAgent extends Vue {

    private role = this.$store.state.profile.roles[0] 
    private state = {
        x : '123'
    }
}
export default AddAgent